/**
 * Retrieves current user's lookup ID from the Redux store.
 *
 * @param {object} state - Redux store.
 * @returns {string}
 */
const currentUserLookupIdSelector = (state) =>
  ((state.Profile || {}).BIOGRAPHICAL || {}).LOOKUPID || '';

/**
 * Retrieves current user's first and last name from the Redux store.
 *
 * @param {object} state - Redux store.
 * @returns {string}
 */
const currentUserFirstLastNameSelector = (state) => {
  const sFirstName = ((state.Profile || {}).BIOGRAPHICAL || {}).FIRSTNAME || '';
  const sLastName = ((state.Profile || {}).BIOGRAPHICAL || {}).LASTNAME || '';
  return {
    sFirstName,
    sLastName,
  };
};

/**
 * Retrieves current user's nickname from the Redux store.
 *
 * @param {object} state - Redux store.
 * @returns {string}
 */
const currentUserNicknameSelector = (state) =>
  state.Profile?.BIOGRAPHICAL?.NICKNAME || '';

export {
  currentUserLookupIdSelector,
  currentUserFirstLastNameSelector,
  currentUserNicknameSelector,
};
